export default import.meta.ROLLUP_FILE_URL_ZNuEq1_eULOnz4ETOzEUkg